/**
 * 양력 → 음력 변환 및 "손없는 날" 판별 유틸 (외부 의존성 없음)
 *
 * 손없는 날: 음력 날짜 끝자리가 9 또는 0인 날 (음력 9·10·19·20·29·30일).
 *   민간에서 "손(악귀)"이 없다고 보는 날로, 이사·개업 등에 선호.
 *
 * 음력 변환은 1900~2100년 정보를 담은 lunarInfo 비트 테이블로 계산한다.
 *   각 원소(연도별)는 윤달 위치와 12~13개 월의 대소(30/29일)를 비트로 인코딩.
 */

// 1900 ~ 2100 (201개)
const lunarInfo = [
  0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2,
  0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977,
  0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970,
  0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557,
  0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573, 0x052b0, 0x0a9a8, 0x0e950, 0x06aa0,
  0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0,
  0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0, 0x195a6,
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570,
  0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x05ac0, 0x0ab60, 0x096d5, 0x092e0,
  0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5,
  0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530,
  0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45,
  0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0,
  0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4, 0x0aae0,
  0x0a2e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0, 0x055d4,
  0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0, 0x052b0,
  0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4, 0x0d160,
  0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a2d0, 0x0d150, 0x0f252,
  0x0d520,
];

const MIN_YEAR = 1900;
const MAX_YEAR = 2100;
const BASE = Date.UTC(1900, 0, 31); // 음력 1900-01-01 = 양력 1900-01-31
const DAY_MS = 86400000;

// 해당 연도의 윤달(없으면 0)
const leapMonth = (y: number) => lunarInfo[y - MIN_YEAR] & 0xf;
// 윤달의 일수(윤달 없으면 0)
const leapDays = (y: number) =>
  leapMonth(y) ? (lunarInfo[y - MIN_YEAR] & 0x10000 ? 30 : 29) : 0;
// 평월(m)의 일수 (30 또는 29)
const monthDays = (y: number, m: number) =>
  lunarInfo[y - MIN_YEAR] & (0x10000 >> m) ? 30 : 29;
// 음력 한 해의 총 일수
const lunarYearDays = (y: number) => {
  let sum = 0;
  for (let m = 1; m <= 12; m++) sum += monthDays(y, m);
  return sum + leapDays(y);
};

export interface LunarDate {
  year: number;
  month: number;
  day: number;
  isLeap: boolean;
}

/** 양력 Date → 음력 날짜로 변환 (지원 범위를 벗어나면 null) */
export function solarToLunar(date: Date): LunarDate | null {
  const y = date.getFullYear();
  if (y < MIN_YEAR || y > MAX_YEAR) return null;

  // 타임존 영향을 없애기 위해 UTC 자정 기준 일수 차이로 계산
  let offset = Math.round(
    (Date.UTC(y, date.getMonth(), date.getDate()) - BASE) / DAY_MS
  );

  let i: number;
  let temp = 0;
  for (i = MIN_YEAR; i <= MAX_YEAR && offset > 0; i++) {
    temp = lunarYearDays(i);
    offset -= temp;
  }
  if (offset < 0) {
    offset += temp;
    i--;
  }
  const lunarYear = i;
  const leap = leapMonth(lunarYear);
  let isLeap = false;

  for (i = 1; i < 13 && offset > 0; i++) {
    if (leap > 0 && i === leap + 1 && !isLeap) {
      --i;
      isLeap = true;
      temp = leapDays(lunarYear);
    } else {
      temp = monthDays(lunarYear, i);
    }
    if (isLeap && i === leap + 1) isLeap = false;
    offset -= temp;
  }
  if (offset === 0 && leap > 0 && i === leap + 1) {
    if (isLeap) {
      isLeap = false;
    } else {
      isLeap = true;
      --i;
    }
  }
  if (offset < 0) {
    offset += temp;
    --i;
  }

  return { year: lunarYear, month: i, day: offset + 1, isLeap };
}

/** 해당 양력 날짜가 "손없는 날"인지 여부 (음력 끝자리 9 또는 0) */
export function isSonEomNeunNal(date: Date): boolean {
  const lunar = solarToLunar(date);
  if (!lunar) return false;
  const last = lunar.day % 10;
  return last === 9 || last === 0;
}

export const LUNAR_RANGE = { MIN_YEAR, MAX_YEAR };
